'use strict';

import anime from 'animejs'

class PhotoModal {
	constructor() {
		this.container = document.createElement("div");
		this.container.classList.add("ModalContainer", "-photo");
		this.container.addEventListener("click", (event)=>{
			this.hide();
		});

		this.layer = document.createElement("div");
		this.layer.classList.add("Modal__backdrop");

		this.modal = document.createElement("div");
		this.modal.classList.add("ModalContainer__Flexbox");
		this.modal.style.alignItems = "center";
		this.modal.style.justifyContent = "center";

		this.container.appendChild(this.modal);
	}

	show(photoUrl) {
		this.image = new Image();

		this.image.style.opacity = 0;
		this.image.style.maxWidth = "70%";
		this.image.style.maxHeight = "70%";
		this.image.src = photoUrl;
		this.image.addEventListener("load", (event)=>{
			if (this.imageFade) {
				this.imageFade.pause();
			}
			this.imageFade = anime({targets: this.image, opacity: 1, elasticity: 0, duration: 1000, ease: 'linear'});
		});
		this.image.addEventListener("click", (event)=>{ event.stopPropagation(); });
		this.modal.appendChild(this.image);

		this.container.style.display = "block";
		this.layer.style.display = "block";
		this.layer.style.opacity = 0;

		document.body.appendChild(this.container);
		document.body.appendChild(this.layer);

		if (this.fadeAnime) {
			this.fadeAnime.pause();
		}

		this.fadeAnime = anime({targets: [this.layer], opacity: 1, elasticity: 0, duration: 1000, ease: 'linear'});
	}

	hide() {
		if (this.imageFade) {
			this.imageFade.pause();
		}
		if (this.fadeAnime) {
			this.fadeAnime.pause();
		}

		this.fadeAnime = anime({targets: [this.layer, this.image], opacity: 0, elasticity: 0, duration: 400, ease: 'linear', complete:this.hideComplete.bind(this)});
	}

	hideComplete() {
		this.layer.style.display = 'none';
		this.container.style.display = 'none';

		this.modal.removeChild(this.image);
		// this.image = null;
	}

	setModal(element) {
		element.addEventListener("click", (event)=>{
			event.preventDefault();

			let url = element.getAttribute("href");
			this.show(url);
		});
	}

	setModalFromClass(className) {
		let elements = document.getElementsByClassName(className);
		for (let i = 0; i < elements.length; i++) {
			let target = elements[i].getElementsByTagName("a")[0];
			if (target != null) {
				this.setModal(target);
			}
		}
	}
}

export default new PhotoModal();


// WEBPACK FOOTER //
// ./assets/js/PhotoModal.js